import { StepNavigation } from "../StepNavigation";
import { StepDetails } from "../StepDetails";
import { Typography } from "@mui/material";
import { WizardHelp } from "../WizardHelp";

export const PosHistoryStep: React.FC = () => {
  return (
    <>
      <Typography>
        Card Menu contains transactions history with details
      </Typography>
      <StepDetails>
        <WizardHelp />
      </StepDetails>
      <StepNavigation />
    </>
  );
};
